import { gql } from '@apollo/client';

export const FETCH_SIGNED_RECORDS = gql`
  query getSignatures {
    getSignatures {
      _id
      imageUrl
      signedAt
      room {
        name
      }
      user {
        name
        category
      }
      session
      duration
    }
  }
`;

export const FILTER_AND_SEARCH_RECORDS = gql`
  query searchAndFilterSignedRecords(
    $searchValue: String
    $searchType: String
    $date: FilterDateInput
    $session: Int
    $campus: String
  ) {
    searchAndFilterSignedRecords(
      searchValue: $searchValue
      searchType: $searchType
      date: $date
      session: $session
      campus: $campus
    ) {
      _id
      imageUrl
      signedAt
      room {
        name
      }
      user {
        name
        category
      }
      session
      duration
    }
  }
`;


// export const FILTER_AND_SEARCH_RECORDS = gql`
//   mutation searchAndFilterSignedRecords(
//     $searchValue: String
//     $searchType: String
//     $date: FilterDateInput
//     $session: Int
//     $campus: String
//   ) {
//     searchAndFilterSignedRecords(
//       searchValue: $searchValue
//       searchType: $searchType
//       date: $date
//       session: $session
//       campus: $campus
//     ) {
//       _id
//       imageUrl
//       signedAt
//       room {
//         name
//       }
//       user {
//         name
//         category
//       }
//       session
//       duration
//     }
//   }
// `;
